import { Box, Stack, Typography } from '@mui/material';
import { BaseEmployeeDTOSourceEnum, UserDTOLegalTermsActionEnum } from 'probonio-shared-ui/api';
import { CenteredCircularProgress } from 'probonio-shared-ui/component/progress';
import { useTenant } from 'probonio-shared-ui/module/me/hooks';
import { useMeStateSelector } from 'probonio-shared-ui/module/me/types';
import { useMemo } from 'react';
import { Trans } from 'react-i18next';
import { BrandLogo } from '../../component/brand/logo';
import { MobileLayout } from '../../component/layout';
import { FEATURE_ONEPORTAL } from '../../constants';
import { sessionStorageSkippedKey } from './legalTerms.const';
import { LegalTermsInfo } from './LegalTermsInfo';
interface Props {
  children: React.ReactNode;
}

export const LegalTermsGuard: React.FC<Props> = ({ children }) => {
  const employee = useMeStateSelector(state => state.me.employment);

  const employment = useMemo(() => {
    return employee;
  }, [employee]);

  const { tenant } = useTenant();

  const isBikeleasingMigration = FEATURE_ONEPORTAL && employment?.source === BaseEmployeeDTOSourceEnum.Bikeleasing;

  const isEmployeeSkipping = sessionStorage.getItem(sessionStorageSkippedKey) === employment?.id;
  const showLegalTerms =
    employment?.legalTermsAction === UserDTOLegalTermsActionEnum.Consent ||
    (employment?.legalTermsAction === UserDTOLegalTermsActionEnum.Skip && !isEmployeeSkipping);

  if (!employment || !tenant) {
    return <CenteredCircularProgress />;
  }

  if (showLegalTerms) {
    return (
      <MobileLayout>
        <Box
          sx={{
            display: 'flex',
            flexGrow: 1,
          }}
        >
          <Stack
            spacing={2}
            sx={{
              alignItems: 'center',
              padding: 2,
              justifyContent: 'center',
            }}
          >
            <BrandLogo />
            <Typography
              variant="h2"
              data-test-id="legal-terms-guard-title"
              sx={{
                textAlign: 'center',
              }}
            >
              {isBikeleasingMigration ? <Trans i18nKey="legalTerms:guardTitleBikeleasing" /> : <Trans i18nKey="legalTerms:guardTitle" />}
            </Typography>
            <Typography
              component="span"
              variant="body2"
              data-test-id="legal-terms-consent-done"
              sx={{
                textAlign: 'center',
              }}
            >
              {isBikeleasingMigration ? (
                <Trans i18nKey="legalTerms:guardSubtitleBikeleasing" />
              ) : (
                <Trans i18nKey="legalTerms:guardSubtitle" />
              )}
            </Typography>
            <LegalTermsInfo employee={employment} tenantId={tenant.id} action={employment.legalTermsAction!} align="center" />
          </Stack>
        </Box>
      </MobileLayout>
    );
  }

  return children;
};
